import { defineComponent as _defineComponent } from 'vue'
import { ref, defineAsyncComponent, watch } from "vue";
import { useOperationStore } from "@/stores/operation";
import LoadingPopupView from "@/components/tools/LoadingPopupView.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutView',
  props: {
  file: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const operation = useOperationStore();
const DynamicComponent = ref();
const HeaderComponent = ref();
const FooterComponent = ref();


const vueIsAvailable = async (
  vueFolder: string,
  idgame: string,
  file: string
) => {
  try {
    console.log(`@/idgames/${idgame}/${vueFolder}/${file}.vue`);
    await import(`@/idgames/${idgame}/${vueFolder}/${file}.vue`);
    return true;
  } catch (error) {
    return false;
  }
};

const getComponentByDomain = async (
  idgame: string,
  name: string,
  vueFolder: string
) => {
  let folder = idgame;

  const exist = await vueIsAvailable(vueFolder, idgame, name);
  if (!exist) {
    if (operation?.operationData?.operations) {
      folder = "default_platform";
    } else {
      folder = "default";
    }
  }

  return defineAsyncComponent({
    loader: () => {
      return import(`@/idgames/${folder}/${vueFolder}/${name}.vue`);
    },
    loadingComponent: LoadingPopupView,
    delay: 1000,
  });
};

const updateDynamicComponents = async () => {
  DynamicComponent.value = await getComponentByDomain(
    operation?.operationData?.idgame ?? "",
    props.file,
    "views"
  );
  HeaderComponent.value = await getComponentByDomain(
    operation?.operationData?.idgame ?? "",
    "HeaderView",
    "components"
  );

  FooterComponent.value = await getComponentByDomain(
    operation?.operationData?.idgame ?? "",
    "FooterView",
    "components"
  );
};

console.log("props.file", operation?.operationData);

watch(
  () => props.file,
  () => {
    updateDynamicComponents();
  },
  { immediate: true }
);

return { __sfc: true,operation, DynamicComponent, HeaderComponent, FooterComponent, props, vueIsAvailable, getComponentByDomain, updateDynamicComponents }
}

})